import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const AutorizacionReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Crear una autorización
   */
  builder
    .addCase(Types.CREAR_AUTORIZACION_LOADING, (state) => {
      state.crearAutorizacionLoading = true;
      state.crearAutorizacionError = null;
    })
    .addCase(Types.CREAR_AUTORIZACION_SUCCESS, (state, action) => {
      const { crearAutorizacionData } = action;
      state.crearAutorizacionData = crearAutorizacionData;
      state.crearAutorizacionLoading = false;
      state.crearAutorizacionError = null;
    })
    .addCase(Types.CREAR_AUTORIZACION_FAILURE, (state, action) => {
      const { crearAutorizacionError } = action;
      state.crearAutorizacionData = INITIAL_STATE.crearAutorizacionData;
      state.crearAutorizacionLoading = false;
      state.crearAutorizacionError = crearAutorizacionError;
    });

  /**
   * Cancelar una autorización
   */
  builder
    .addCase(Types.CANCELAR_AUTORIZACION_LOADING, (state) => {
      state.cancelarAutorizacionLoading = true;
      state.cancelarAutorizacionError = null;
    })
    .addCase(Types.CANCELAR_AUTORIZACION_SUCCESS, (state, action) => {
      const { cancelarAutorizacionData } = action;
      state.cancelarAutorizacionData = cancelarAutorizacionData;
      state.cancelarAutorizacionLoading = false;
      state.cancelarAutorizacionError = null;
    })
    .addCase(Types.CANCELAR_AUTORIZACION_FAILURE, (state, action) => {
      const { cancelarAutorizacionError } = action;
      state.cancelarAutorizacionData = INITIAL_STATE.cancelarAutorizacionData;
      state.cancelarAutorizacionLoading = false;
      state.cancelarAutorizacionError = cancelarAutorizacionError;
    });

  /**
   * Consultar una autorización
   */
  builder
    .addCase(Types.GET_AUTORIZACION_LOADING, (state) => {
      state.getAutorizacionLoading = true;
      state.getAutorizacionError = null;
    })
    .addCase(Types.GET_AUTORIZACION_SUCCESS, (state, action) => {
      const { getAutorizacionData } = action;
      state.getAutorizacionData = getAutorizacionData;
      state.getAutorizacionLoading = false;
      state.getAutorizacionError = null;
    })
    .addCase(Types.GET_AUTORIZACION_FAILURE, (state, action) => {
      const { getAutorizacionError } = action;
      state.getAutorizacionData = INITIAL_STATE.getAutorizacionData;
      state.getAutorizacionLoading = false;
      state.getAutorizacionError = getAutorizacionError;
    });

  /**
   * Consultar las autorizaciones de un pss
   */
  builder
    .addCase(Types.CONSULTAR_AUTORIZACIONES_LOADING, (state) => {
      state.consultarAutorizacionesLoading = true;
      state.consultarAutorizacionesError = null;
    })
    .addCase(Types.CONSULTAR_AUTORIZACIONES_SUCCESS, (state, action) => {
      const { consultarAutorizacionesData } = action;
      state.consultarAutorizacionesData = consultarAutorizacionesData;
      state.consultarAutorizacionesLoading = false;
      state.consultarAutorizacionesError = null;
    })
    .addCase(Types.CONSULTAR_AUTORIZACIONES_FAILURE, (state, action) => {
      const { consultarAutorizacionesError } = action;
      state.consultarAutorizacionesData =
        INITIAL_STATE.consultarAutorizacionesData;
      state.consultarAutorizacionesLoading = false;
      state.consultarAutorizacionesError = consultarAutorizacionesError;
    });

  /**
   * Reactivar una autorización
   */
  builder
    .addCase(Types.REACTIVAR_AUTORIZACION_LOADING, (state) => {
      state.reactivarAutorizacionLoading = true;
      state.reactivarAutorizacionError = null;
    })
    .addCase(Types.REACTIVAR_AUTORIZACION_SUCCESS, (state, action) => {
      const { reactivarAutorizacionData } = action;
      state.reactivarAutorizacionData = reactivarAutorizacionData;
      state.reactivarAutorizacionLoading = false;
      state.reactivarAutorizacionError = null;
    })
    .addCase(Types.REACTIVAR_AUTORIZACION_FAILURE, (state, action) => {
      const { reactivarAutorizacionError } = action;
      state.reactivarAutorizacionData = INITIAL_STATE.reactivarAutorizacionData;
      state.reactivarAutorizacionLoading = false;
      state.reactivarAutorizacionError = reactivarAutorizacionError;
    });

  /**
   * Limpiar datos de la autorizacion creada
   */
  builder.addCase(Types.LIMPIAR_DATOS_AUTORIZACION_LOADING, (state) => {
    state.limpiarDatosAutorizacionLoading = true;
  });

  /**
   * Consultar una autorización hija de una madre
   */
    builder
    .addCase(Types.CONSULTAR_AUTORIZACION_HIJA_LOADING, (state) => {
      state.consultarAutorizacionHijaLoading = true;
    })
    .addCase(Types.CONSULTAR_AUTORIZACION_HIJA_SUCCESS, (state, action) => {
      const { consultarAutorizacionHijaData } = action;
      state.consultarAutorizacionHijaData = consultarAutorizacionHijaData;
      state.consultarAutorizacionHijaLoading = false;
    });
    
  /**
   * Actualizar form de autorizacion diagnostico
   */
  builder
    .addCase(Types.FORM_AUTORIZACION_DIAGNOSTICO_LOADING, (state) => {
      state.formAutorizacionDiagnosticoLoading = true;
    })
    .addCase(Types.FORM_AUTORIZACION_DIAGNOSTICO_SUCCESS, (state, action) => {
      const { formAutorizacionDiagnosticoData } = action;
      state.formAutorizacionDiagnosticoData = formAutorizacionDiagnosticoData;
      state.formAutorizacionDiagnosticoLoading = false;
      state.getAutorizacionesDiagnosticoLoading = false;
      state.modificarDiagnosticoDefinitivoLoading = false;
      state.confirmarDiagnosticoDefinitivoLoading = false;
    });

  /**
   * Consultar las autorizaciones diagnostico
   */
  builder.addCase(Types.GET_AUTORIZACIONES_DIAGNOSTICO_LOADING, (state) => {
    state.getAutorizacionesDiagnosticoLoading = true;
  });

  /**
   * Modificar diagnostico definitivo
   */
  builder.addCase(Types.MODIFICAR_DIAGNOSTICO_DEFINITIVO_LOADING, (state) => {
    state.modificarDiagnosticoDefinitivoLoading = true;
  });

    /**
   * Confirmar diagnostico definitivo
   */
    builder.addCase(Types.CONFIRMAR_DIAGNOSTICO_DEFINITIVO_LOADING, (state) => {
      state.confirmarDiagnosticoDefinitivoLoading = true;
    });
});
